import React = require("react");
import * as dateMath from 'date-arithmetic';
import { DateTimeField } from "./DateTimeField";



type StartEndDateTimeFieldsProps = {
    start:Date,
    end:Date,
    startLabel:string,
    endLabel:string,
    onChanged:(start:Date, end:Date)=>void
}
export function StartEndDateTimeFields(props:StartEndDateTimeFieldsProps): JSX.Element {

    function handleStartChange(value:Date){
        const {start,end} = maybeAdjustEnd(props.start, value, props.end);
        props.onChanged(start,end);
    }

    function handleEndChange(value:Date|null){
        const {start,end} = maybeAdjustStart(props.start, props.end, value);
        props.onChanged(start,end);
    }

    return (
        // Make it fill two columns
        <>
            <DateTimeField 
                value={props.start} 
                label={props.startLabel} 
                onChanged={handleStartChange}
                validator={() => { return {valid:true} }} />
            
            <DateTimeField 
                value={props.end} 
                label={props.endLabel} 
                onChanged={handleEndChange}
                validator={() => { return {valid:true} }} />
        </>
    );
}

export function maybeAdjustEnd(oldStart:Date, newStart:Date, end:Date):{ start:Date, end:Date }
{
    let newEnd = end;
    if(newStart >= end){
        const diff = dateMath.diff(oldStart, end, 'milliseconds');
        newEnd = dateMath.add(newStart, diff, 'milliseconds');
    }
    return {start:newStart, end:newEnd};
}

export function maybeAdjustStart(start:Date, oldEnd:Date, newEnd:Date):{ start:Date, end:Date }
{
    let newStart = start;
    if(newEnd <= start){
        const diff = dateMath.diff(start, oldEnd, 'milliseconds');
        newStart = dateMath.add(newEnd, -diff, 'milliseconds');
    }
    return {start:newStart, end:newEnd};
}


